import React from 'react';
import {Box, Pagination, Stack, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicPagination = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                    Basic Pagination (Default)
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    title={"Basic menu"}
                    value={"<Pagination count={10} />"}>
                    <Pagination count={10} />
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default BasicPagination;